import {ChangeDetectionStrategy,Component,DestroyRef,inject} from '@angular/core';
import {MATERIAL_IMPORTS} from '../../../shared/material-imports';
import {COMMON_IMPORTS} from '../../../shared/common-imports';
import {environment} from '../../../../environments/environment';
import {BreakpointObserver,Breakpoints} from '@angular/cdk/layout';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {CUSTOM_BREAKPOINT} from '../../../common/enums/custom-breakpoint.enum';
import {ConsentService} from '../../../common/consent/consent.service';

@Component({
	selector:'app-footer',
	changeDetection:ChangeDetectionStrategy.OnPush,
	imports:[
		...MATERIAL_IMPORTS,
		...COMMON_IMPORTS
	],
	templateUrl:'./footer.html',
	styleUrl:'./footer.scss'
})
export class FooterComponent{
	private readonly consentService=inject(ConsentService);
	private readonly breakpointObserver=inject(BreakpointObserver);
	private readonly destroyRef=inject(DestroyRef);
	protected readonly environment=environment;
	isXSmallWindow=this.breakpointObserver.observe([Breakpoints.XSmall,Breakpoints.Small])
	.pipe(
		takeUntilDestroyed(this.destroyRef)
	);
	isXXSmallWindow=this.breakpointObserver.observe([CUSTOM_BREAKPOINT.XXSmall])
	.pipe(
		takeUntilDestroyed(this.destroyRef)
	);
	
	

	openCookieSettings():void{
		this.consentService.reopen();
	}
	
}
